import { render, staticRenderFns } from "./MultipleChoiceSection.vue?vue&type=template&id=6aff3af4&scoped=true&"
import script from "./MultipleChoiceSection.vue?vue&type=script&lang=js&"
export * from "./MultipleChoiceSection.vue?vue&type=script&lang=js&"
import style0 from "./MultipleChoiceSection.vue?vue&type=style&index=0&id=6aff3af4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aff3af4",
  null
  
)

component.options.__file = "MultipleChoiceSection.vue"
export default component.exports